import {useMutation, MutationOptions} from '@tanstack/react-query';
import {AxiosError} from 'axios';
import {ColumnNames, ShipmentIds} from '@shipwell/backend-core-singlerequestparam-sdk';
import {getFilteredColumnNames} from './utils';
import {getShipmentsDownloadCsv} from 'App/api/referenceData/typed';

export type GetShipmentsDownloadCsvResponse = Awaited<ReturnType<typeof getShipmentsDownloadCsv>>;
export type GetShipmentsDownloadCsvError = AxiosError<{error_message: string}>;
export type GetShipmentsDownloadCsvMutationParams = {shipmentIds: ShipmentIds; columnNames: ColumnNames};

export type GetShipmentsDownloadCsvMutationOptions = Omit<
  MutationOptions<GetShipmentsDownloadCsvResponse, GetShipmentsDownloadCsvError, GetShipmentsDownloadCsvMutationParams>,
  'mutationFn'
>;

export const useGetShipmentsDownloadCsvMutation = (options: GetShipmentsDownloadCsvMutationOptions = {}) => {
  return useMutation({
    mutationFn: ({shipmentIds, columnNames}: GetShipmentsDownloadCsvMutationParams) =>
      getShipmentsDownloadCsv({
        shipmentIds,
        columnNames: getFilteredColumnNames(columnNames)
      }),
    ...options
  });
};
